import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import {
  enUS,
  ptBR
} from './locales'

export const defaultLanguage = 'pt-BR'

export const resources = {
  'en-US': {
    translation: enUS
  },
  'pt-BR': {
    translation: ptBR
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: defaultLanguage,
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
